import { Component, OnInit } from "@angular/core";
import { SharedImportsModule } from "../../shared/shared-imports.module";
import { Router } from "@angular/router";
import { EducationService } from "../../services/education/education.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-select-user",
  standalone: false,
  imports: [SharedImportsModule],
  templateUrl: "./select-user.component.html",
})
export class SelectUserComponent implements OnInit {
  name: string;
  users: { fullName: string; id: number }[] = [];
  userForm: FormGroup;
  validationMessages: string[] = [];

  constructor(
    private router: Router,
    private educationService: EducationService,
    private userService: ERTUserService,
    private fb: FormBuilder,
    private loggedUserService: LoggedUserService
  ) {
    this.userForm = this.fb.group({
      selectedUser: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      const facilityId = Number(user.facilityId) || 1;

      this.userService
        .getAllERTUsers(facilityId)
        .subscribe((data: ERTUser[]) => {
          this.users = data
            .filter(
              (user) =>
                !user.picklistValues.some(
                  (picklist) => picklist.value === "Inactive"
                )
            )
            .map((user) => ({
              fullName: user.fullName,
              lastName: user.lastName,
              id: user.id,
            }))
            .sort((a, b) => a.lastName.localeCompare(b.lastName));
        });
    });
  }

  setUser(event: Event) {
    var userSelectElement = event.target as HTMLSelectElement;
    const selectedUser = this.users.find(
      (user) => user.fullName === userSelectElement.value
    );
    if (selectedUser) {
      this.name = selectedUser.fullName;
      this.userForm.get("selectedUser")?.setValue(this.name);
    }
  }

  nextStep() {
    this.validationMessages = this.educationService.validateCreateForm(
      this.userForm
    );
    const selectedUser = this.users.find((user) => user.fullName === this.name);
    if (selectedUser) {
      this.router.navigate(["/ert-education/new-entry"], {
        queryParams: { name: selectedUser.fullName, userId: selectedUser.id },
      });
    }
  }
}
